import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ANNUAL_REPORTS_TYPES } from './annualReportsTypes';
import { 
  fetchAnnualReportsSuccess, 
  fetchAnnualReportsFailure 
} from './annualReportsActions';
import { annualReportsApi } from './annualReportsApi';

// Worker Saga
function* fetchAnnualReportsSaga(action) {
  try {
    const response = yield call(annualReportsApi.fetchAnnualReports, action.payload);
    yield put(fetchAnnualReportsSuccess(response));
  } catch (error) {
    yield put(fetchAnnualReportsFailure(error));
  }
}

// Watcher Saga
function* annualReportsSaga() {
  yield takeLatest(ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_REQUEST, fetchAnnualReportsSaga);
}

export default annualReportsSaga;